module.exports = __webpack_public_path__ + "static/media/bg-bottom.d8d67470.jpg";